var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(
          "Terminvereinbarung mit " +
            _vm._s(_vm.applicantName ? _vm.applicantName : "der Person") +
            ":"
        )
      ]),
      _vm._v(" "),
      _c("JonInfo", {
        staticClass: "mt-1",
        scopedSlots: _vm._u([
          {
            key: "message",
            fn: function() {
              return [
                _vm._v(
                  "\n\t\t\tBereits gebuchte oder von dir vorgeschlagene Termine siehst du\n\t\t\t"
                ),
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.openAppointments.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("hier")]
                ),
                _vm._v(".\n\t\t")
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c("b-col", { attrs: { md: "5" } }, [
            _c("div", { staticClass: "sections" }, [
              _c(
                "section",
                [
                  _c("h3", [_vm._v("Termingrund")]),
                  _vm._v(" "),
                  _c("MultiCheckboxSelect", {
                    attrs: { options: _vm.reasonOptions },
                    on: { input: _vm.reasonsChanged },
                    model: {
                      value: _vm.reasons,
                      callback: function($$v) {
                        _vm.reasons = $$v
                      },
                      expression: "reasons"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "7" } },
            [
              _c("div", { staticClass: "sections" }, [
                _vm.typeEligible
                  ? _c(
                      "section",
                      { staticClass: "mt-3 mt-md-0" },
                      [
                        _c("h3", [_vm._v("Terminart")]),
                        _vm._v(" "),
                        _c("Select", {
                          attrs: {
                            options: _vm.typeOptions,
                            "undefined-text-option-text": "--- Terminart ---"
                          },
                          on: { input: _vm.typeChanged },
                          model: {
                            value: _vm.type,
                            callback: function($$v) {
                              _vm.type = $$v
                            },
                            expression: "type"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.reasons
                ? _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c("b-col", { attrs: { md: "4" } }, [
                        _c("div", { staticClass: "sections" }, [
                          _c(
                            "section",
                            [
                              _c("h3", [_vm._v("Dauer")]),
                              _vm._v(" "),
                              _c("SingleSelect", {
                                attrs: {
                                  characteristics:
                                    _vm.appointmentDurationCharacteristics,
                                  "undefined-text-option-text": "--- Dauer ---"
                                },
                                model: {
                                  value: _vm.duration,
                                  callback: function($$v) {
                                    _vm.duration = $$v
                                  },
                                  expression: "duration"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.onlineActivityEligible
                        ? _c("b-col", { attrs: { md: "8" } }, [
                            _c("div", { staticClass: "sections" }, [
                              _c(
                                "section",
                                [
                                  _c("h3", [_vm._v("Onlinetätigkeit")]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      model: {
                                        value: _vm.onlineActivity,
                                        callback: function($$v) {
                                          _vm.onlineActivity = $$v
                                        },
                                        expression: "onlineActivity"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tJa (für Test, Assessment oder Probearbeit)\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === _vm.types.phoneCall
                ? _c(
                    "div",
                    { staticClass: "mt-2 font-weight-bold color-primary" },
                    [
                      _vm._v(
                        "\n\t\t\t\tDu erhältst die Telefonnummer " +
                          _vm._s(
                            _vm.applicantName
                              ? "von " + _vm.applicantName
                              : "der Person"
                          ) +
                          "\n\t\t\t\tnach Termin-Bestätigung.\n\t\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.onlineActivityEligible && _vm.onlineActivity) ||
              _vm.type === _vm.types.videoCall
                ? _c(
                    "div",
                    { staticClass: "mt-2 font-weight-bold color-primary" },
                    [
                      _vm._v(
                        "\n\t\t\t\tLink und Zugangsdaten können von dir an " +
                          _vm._s(
                            _vm.applicantName ? _vm.applicantName : "die Person"
                          ) +
                          " gesendet\n\t\t\t\twerden nach Rückbestätigung des Termins.\n\t\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === _vm.types.personalAtOrganisation
                ? _c(
                    "div",
                    { staticClass: "mt-2 font-weight-bold color-primary" },
                    [
                      _vm._v(
                        "\n\t\t\t\tAdresse: " +
                          _vm._s(_vm.customer.street) +
                          " " +
                          _vm._s(_vm.customer.streetNumber) +
                          ", " +
                          _vm._s(_vm.customer.zip) +
                          " " +
                          _vm._s(_vm.customer.city) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sections mt-4" },
        [
          _vm.type
            ? [
                _vm.type === _vm.types.personalNotAtOrganisation
                  ? _c(
                      "section",
                      [
                        _c("h3", [
                          _vm._v(
                            "\n\t\t\t\t\tPersönlicher Termin an einem anderen Ort - nicht an der Adresse deines Unternehmen/deiner\n\t\t\t\t\tOrganisation:\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("AddressForm", {
                          staticClass: "mt-2",
                          model: {
                            value: _vm.differentAddress,
                            callback: function($$v) {
                              _vm.differentAddress = $$v
                            },
                            expression: "differentAddress"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.duration
                  ? _c("section", [
                      _c("h3", [
                        _vm._v(
                          _vm._s(
                            "TeilnehmerInnen seitens " +
                              _vm.customer.companyName
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              model: {
                                value: _vm.selfParticipation,
                                callback: function($$v) {
                                  _vm.selfParticipation = $$v
                                },
                                expression: "selfParticipation"
                              }
                            },
                            [_vm._v("Ich nehme teil")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              on: { change: _vm.furtherParticipantsChanged },
                              model: {
                                value: _vm.furtherParticipants,
                                callback: function($$v) {
                                  _vm.furtherParticipants = $$v
                                },
                                expression: "furtherParticipants"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\tEs gibt weitere Teilnehmer\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.furtherParticipants
                            ? _c(
                                "div",
                                { staticClass: "pl-3 mt-2" },
                                _vm._l(_vm.furtherParticipantsList, function(
                                  participant,
                                  i
                                ) {
                                  return _c("Participant", {
                                    key: participant.id,
                                    staticClass: "mt-1",
                                    attrs: {
                                      participant: participant,
                                      "is-last":
                                        i ===
                                        _vm.furtherParticipantsList.length - 1
                                    },
                                    on: {
                                      add: _vm.addFurtherParticipant,
                                      change: function($event) {
                                        return _vm.changeFurtherParticipant(
                                          participant,
                                          $event
                                        )
                                      },
                                      remove: function($event) {
                                        return _vm.removeFurtherParticipant(
                                          participant
                                        )
                                      }
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.participantsChosen && _vm.participantsValid
                  ? _c(
                      "section",
                      [
                        _c("h3", [_vm._v("Terminmöglichkeiten")]),
                        _vm._v(" "),
                        !_vm.potentialDates || _vm.potentialDates.length === 0
                          ? _c("JonInfo", {
                              staticClass: "mt-1",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "message",
                                    fn: function() {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\tGib 3 bis 5 Termine zur Auswahl, dadurch wird die Abstimmung beschleunigt und vereinfacht.\n\t\t\t\t\t"
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                1193065957
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "FormGroup",
                          [
                            _c("PotentialDates", {
                              staticClass: "mb-2",
                              model: {
                                value: _vm.potentialDates,
                                callback: function($$v) {
                                  _vm.potentialDates = $$v
                                },
                                expression: "potentialDates"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.potentialDatesValid &&
                _vm.onlineActivityEligible &&
                _vm.onlineActivity
                  ? _c(
                      "section",
                      [
                        _c("h3", [
                          _vm._v(
                            "Die Onlinetätigkeit (für Test, Assessment oder Probearbeit):"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "FormGroup",
                          {
                            attrs: {
                              state: _vm.onlineActivityExecutionValid,
                              "invalid-feedback": "Bitte triff eine Auswahl"
                            }
                          },
                          [
                            _c("RadioGroup", {
                              attrs: {
                                options: _vm.onlineActivityExecutionOptions,
                                stacked: ""
                              },
                              model: {
                                value: _vm.onlineActivityExecution,
                                callback: function($$v) {
                                  _vm.onlineActivityExecution = $$v
                                },
                                expression: "onlineActivityExecution"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.potentialDatesValid
                  ? _c("section", [
                      _c("h3", [_vm._v("Gegenvorschläge")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "FormGroup",
                              {
                                staticClass: "mt-2",
                                attrs: {
                                  state: _vm.counterProposalMaxTimeValid,
                                  "invalid-feedback":
                                    "Bitte wähle eine Uhrzeit aus",
                                  "feedback-beneath": ""
                                }
                              },
                              [
                                _c("TimePicker", {
                                  attrs: { "focus-hour": 14 },
                                  model: {
                                    value: _vm.counterProposalMaxTime,
                                    callback: function($$v) {
                                      _vm.counterProposalMaxTime = $$v
                                    },
                                    expression: "counterProposalMaxTime"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center flex-column-reverse flex-md-row mt-5"
        },
        [
          _vm.withCancelButton
            ? _c(
                "div",
                { staticClass: "flex-grow-1 ml-0 ml-md-2 mt-2 mt-md-0" },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$emit("cancel")
                        }
                      }
                    },
                    [_vm._v("Abbrechen")]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("Button", {
                attrs: {
                  text: "Terminvorschlag senden",
                  icon: "checkmark",
                  disabled: !_vm.dataValid || _vm.sendingRequest,
                  loading: _vm.sendingRequest
                },
                on: { click: _vm.sendRequest }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-grow-1 mr-2" }, [
      _c("div", [
        _vm._v(
          "\n\t\t\t\t\t\t\tSollten deine Terminvorschläge nicht möglich sein, erhältst du eine Benachrichtigung.\n\t\t\t\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n\t\t\t\t\t\t\tSolltest du Gegenvorschläge erhalten:\n\t\t\t\t\t\t\t"
        ),
        _c("b", [_vm._v("Wann können Termine spätestens starten?")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }